module.exports = "images/apple-icon-72x72.36c175a4d159f4bdf7f75d884735a2c9.png";